<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs v-model="tab" @change="load">
        <a-tab-pane key="1" tab="定制下单选项" />
        <a-tab-pane key="2" tab="共享工作室附件要求" />
        <a-tab-pane key="industry" tab="商品行业属性" />
      </a-tabs>

      <template v-if="tab !== 'industry'">
        <a-alert
          :message="tab === '1'
            ? '定制下单选项：客户购买定制商品时需要选择或填写的内容。先在这里维护标题和选项，再到定制商品编辑页勾选适用项。'
            : '共享工作室附件要求：定制业务提交设计稿、PDF 等项目附件时使用，不属于商品参数。'"
          type="info"
          show-icon
          class="notice"
        />
        <div class="bar"><a-button type="primary" @click="openAttr()">新增属性</a-button></div>
        <a-table row-key="aid" :data-source="attributes" :columns="attributeColumns" :pagination="false" bordered>
          <template slot="type" slot-scope="t, r">{{ typeName(r.attr_type) }}</template>
          <template slot="required" slot-scope="t, r">{{ Number(r.is_required) === 1 ? '是' : '否' }}</template>
          <template slot="status" slot-scope="t, r"><a-tag :color="Number(r.status) === 1 ? 'green' : 'default'">{{ Number(r.status) === 1 ? '启用' : '禁用' }}</a-tag></template>
          <template slot="op" slot-scope="t, r">
            <a @click="openAttr(r)">编辑</a>
            <template v-if="[1, 2].includes(Number(r.attr_type))"><a-divider type="vertical" /><a @click="openOptions(r)">选项管理</a></template>
            <a-divider type="vertical" />
            <a-popconfirm title="确认删除？" @confirm="removeAttr(r)"><a class="danger">删除</a></a-popconfirm>
          </template>
        </a-table>
      </template>

      <industry-library v-else :key="'industry-'+industryMallType" :initial-order-type="industryMallType" />

      <a-modal :title="tab === '1' ? '定制下单选项' : '附件要求'" :visible="attrVisible" @ok="saveAttr" @cancel="attrVisible = false">
        <a-form-model :model="attrForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="中文名称"><a-input v-model="attrForm.attrName" /></a-form-model-item>
          <a-form-model-item label="英文名称"><a-input v-model="attrForm.attrNameEn" /></a-form-model-item>
          <a-form-model-item label="类型">
            <a-select v-model="attrForm.attrType">
              <a-select-option :value="1">单选</a-select-option><a-select-option :value="2">多选</a-select-option>
              <a-select-option :value="3">是否</a-select-option><a-select-option :value="4">文本</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="必填"><a-switch v-model="attrRequired" /></a-form-model-item>
          <a-form-model-item label="备注"><a-input v-model="attrForm.remark" /></a-form-model-item>
          <a-form-model-item label="显示顺序"><a-input-number v-model="attrForm.sort" /><div class="hint">数字越小越靠前</div></a-form-model-item>
        </a-form-model>
      </a-modal>

      <a-drawer title="选项管理" width="600" :visible="optionsVisible" @close="optionsVisible = false">
        <div class="bar"><a-button type="primary" @click="openOption()">新增选项</a-button></div>
        <a-table row-key="aid" :data-source="options" :pagination="false" :columns="optionColumns" bordered>
          <template slot="op" slot-scope="t, r"><a @click="openOption(r)">编辑</a><a-divider type="vertical" /><a @click="deleteOption(r)">删除</a></template>
        </a-table>
      </a-drawer>

      <a-modal title="属性选项" :visible="optionVisible" @ok="saveOptionRow" @cancel="optionVisible = false">
        <a-form-model :model="optionForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="中文名称"><a-input v-model="optionForm.optionName" /></a-form-model-item>
          <a-form-model-item label="英文名称"><a-input v-model="optionForm.optionNameEn" /></a-form-model-item>
          <a-form-model-item label="显示顺序"><a-input-number v-model="optionForm.sort" /></a-form-model-item>
        </a-form-model>
      </a-modal>

    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  listAttributes, saveAttribute, removeAttribute, listOptions, saveOption, removeOption,

} from '@/api/dkmall/catalog-config'
import IndustryLibrary from './IndustryLibrary.vue'

export default {
  name: 'DkMallCatalogConfig',
  components: { IndustryLibrary },
  data() {
    return {
      tab: this.$route.query.tab || '1',
      attributes: [], options: [],
      industryMallType: Number(this.$route.query.orderType) === 12 ? 12 : 3,
      activeAttr: {}, attrVisible: false, optionsVisible: false, optionVisible: false,
      attrForm: {}, optionForm: {},
      attributeColumns: [
        { title: '中文名称', dataIndex: 'attr_name' }, { title: '英文名称', dataIndex: 'attr_name_en' },
        { title: '类型', scopedSlots: { customRender: 'type' } }, { title: '必填', scopedSlots: { customRender: 'required' } },
        { title: '备注', dataIndex: 'remark' }, { title: '状态', scopedSlots: { customRender: 'status' } },
        { title: '操作', scopedSlots: { customRender: 'op' }, width: 200 }
      ],
      optionColumns: [
        { title: '中文名称', dataIndex: 'option_name' }, { title: '英文名称', dataIndex: 'option_name_en' },
        { title: '显示顺序', dataIndex: 'sort' }, { title: '操作', scopedSlots: { customRender: 'op' }, width: 120 }
      ]
    }
  },
  computed: {
    scope() { return Number(this.tab) },
    attrRequired: {
      get() { return this.attrForm.required === 1 },
      set(v) { this.attrForm.required = v ? 1 : 0 }
    }
  },
  created() { this.load() },
  watch: { '$route.query': { handler(q) { this.tab=q.tab||'1'; this.industryMallType=Number(q.orderType)===12?12:3; this.load() } } },
  methods: {
    load() {
      if (this.tab === 'industry') return
      listAttributes(this.scope).then(r => { this.attributes = r.data || [] })
    },
    typeName(v) { return ({ 1: '单选', 2: '多选', 3: '是否', 4: '文本' })[Number(v)] },
    openAttr(r) {
      this.attrForm = r
        ? { aid: r.aid, scope: this.scope, attrName: r.attr_name, attrNameEn: r.attr_name_en, attrType: Number(r.attr_type), required: Number(r.is_required), remark: r.remark, sort: Number(r.sort), status: Number(r.status) }
        : { scope: this.scope, attrType: 1, required: 0, sort: 100, status: 1 }
      this.attrVisible = true
    },
    saveAttr() { saveAttribute(this.attrForm).then(() => { this.attrVisible = false; this.load() }) },
    removeAttr(r) { removeAttribute(r.aid, this.scope).then(this.load) },
    openOptions(r) { this.activeAttr = r; this.optionsVisible = true; this.loadOptions() },
    loadOptions() { listOptions(this.activeAttr.aid, this.scope).then(r => { this.options = r.data || [] }) },
    openOption(r) {
      this.optionForm = r
        ? { aid: r.aid, optionName: r.option_name, optionNameEn: r.option_name_en, sort: Number(r.sort), status: Number(r.status) }
        : { optionName: '', optionNameEn: '', sort: 100, status: 1 }
      this.optionVisible = true
    },
    saveOptionRow() { saveOption(this.activeAttr.aid, this.scope, this.optionForm).then(() => { this.optionVisible = false; this.loadOptions() }) },
    deleteOption(r) { removeOption(this.activeAttr.aid, r.aid, this.scope).then(this.loadOptions) }
  }
}
</script>

<style scoped>
.bar { display:flex; gap:12px; margin-bottom:16px; align-items:center; }
.notice { margin-bottom:16px; }
.danger { color:#f5222d; }
.hint { color:#8c8c8c; font-size:12px; }
</style>
